import { AddressInfo } from './types'

export const containerStyle = {
  width: '100%',
  height: '400px',
}

export const extractAddressInfo = (
  addressComponents: google.maps.GeocoderAddressComponent[]
): AddressInfo => {
  let city = ''
  let postalCode = ''
  let country = ''
  let countryCode = ''

  for (const component of addressComponents) {
    const { types } = component
    if (types.includes('locality')) {
      city = component.long_name
    }
    if (types.includes('postal_code')) {
      postalCode = component.long_name
    }
    if (types.includes('country')) {
      country = component.long_name
      countryCode = component.short_name
    }
  }

  return { city, postalCode, country, countryCode }
}
